module.exports = __webpack_public_path__ + "static/media/Page01_org.492bc65d.jpg";